export class Util {
  // Class to implement util methods in the app;

  public static findDescriptionById(id: number, list: any): string {
    const description = list.find(x => x.id == id).description;
    return description;
  }
}
